import { findGeoLocations, getDataSection } from '@/api/location'
import i18n from '@/i18n'
import router from '@/router/index.js'
const state = {
  position: {
    latitude: null,
    longitude: null
  },
  geolevels: [],
  geolevelselected: null,
  dataSidebarExport: null
}

const mutations = {
  SET_LOCATION: (state, location) => {
    if (location === null) {
      state.position = {
        latitude: null,
        longitude: null
      }
      state.geolevels = []
      state.geolevelselected = null
    } else {
      state.position = {
        latitude: location.place.geometry.location.lat(),
        longitude: location.place.geometry.location.lng()
      }
      location.levels = setGeolevelsTranslate(location.levels)
      state.geolevels = location.levels
      const geoselected = location.levels.filter(item => { return item.level === 3 })
      if (router.currentRoute.query.latitude && router.currentRoute.query.longitude && router.currentRoute.query.level) {
        state.geolevelselected = location.levels[router.currentRoute.query.level]
      } else {
        state.geolevelselected = geoselected.length > 0 ? geoselected[0] : location.levels[0]
      }
    }
  },
  SET_SELECTED_LEVEL: (state, level) => {
    state.geolevelselected = level
  },
  SET_DATA_SIDEBAR_EXPORT: (state, val) => {
    state.dataSidebarExport = val
  }
}

const actions = {
  searchlocations({ commit }, place) {
    return new Promise((resolve, reject) => {
      findGeoLocations({
        latitude: place.geometry.location.lat(),
        longitude: place.geometry.location.lng()
      }).then((response) => {
        commit('SET_LOCATION', {
          place: place,
          levels: response.data
        })
        resolve()
      }).catch((error) => {
        console.error(error)
        commit('SET_LOCATION', null)
        reject()
      })
    })
  },
  getDataSection({ commit }, query) {
    return new Promise((resolve, reject) => {
      getDataSection(query).then((response) => {
        resolve(response.data)
      }).catch((error) => {
        console.error(error)
        commit('SET_LOCATION', null)
        reject()
      })
    })
  },
  setgeolevel({ commit }, geolevel) {
    return new Promise((resolve, reject) => {
      commit('SET_SELECTED_LEVEL', geolevel)
      resolve()
    })
  },
  setDataSidebarExport({ state, commit }, { value }) {
    commit('SET_DATA_SIDEBAR_EXPORT', value)
  }
}

function setGeolevelsTranslate(geolevels) {
  geolevels.forEach((geolevel, i) => {
    switch (geolevel.levelname) {
      case 'Country':
        geolevels[i].levelname = i18n.t('maps.country')
        geolevels[i].literalLevelname = 'maps.country'
        break
      case 'Region':
        geolevels[i].levelname = i18n.t('assetData.region')
        geolevels[i].literalLevelname = 'assetData.region'
        break
      case 'Province':
        geolevels[i].levelname = i18n.t('maps.province')
        geolevels[i].literalLevelname = 'maps.province'
        break
      case 'Municipality':
        geolevels[i].levelname = i18n.t('maps.municipality')
        geolevels[i].literalLevelname = 'maps.municipality'
        break
      case 'Infra Municipality':
        geolevels[i].levelname = i18n.t('infra-municipality')
        geolevels[i].literalLevelname = 'infra-municipality'
        break
      case 'Census District':
        geolevels[i].levelname = i18n.t('maps.census-district')
        geolevels[i].literalLevelname = 'maps.census-district'
        break
      case 'Neighborhood':
        geolevels[i].levelname = i18n.t('neighborhood')
        geolevels[i].literalLevelname = 'neighborhood'
        break
      case 'Census':
        geolevels[i].levelname = i18n.t('census')
        geolevels[i].literalLevelname = 'census'
        break
      case 'Zip Code':
        geolevels[i].levelname = i18n.t('assetData.zipcode')
        geolevels[i].literalLevelname = 'assetData.zipcode'
        break
      default:
        break
    }
  })

  return geolevels
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
